import { FC } from "react";
import { IconPropsType } from ".";

export const Bell: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="14"
      height="20"
      viewBox="0 0 14 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8462 16.0769V8.84618C12.8462 5.57495 10.1943 2.9231 6.92308 2.9231C3.65185 2.9231 1 5.57495 1 8.84618V16.0769C1 16.6292 1.44771 17.0769 2 17.0769H11.8462C12.3984 17.0769 12.8462 16.6292 12.8462 16.0769ZM6.92308 1.9231C3.09957 1.9231 0 5.02267 0 8.84618V16.0769C0 17.1815 0.895429 18.0769 2 18.0769H11.8462C12.9507 18.0769 13.8462 17.1815 13.8462 16.0769V8.84618C13.8462 5.02267 10.7466 1.9231 6.92308 1.9231Z"
        fill={props.color ?? "black"}
      />
      <path
        d="M5.5 17.5H8.5V18.5C8.5 19.0523 8.05228 19.5 7.5 19.5H6.5C5.94772 19.5 5.5 19.0523 5.5 18.5V17.5Z"
        stroke={props.color ?? "black"}
      />
      <path
        d="M7.5 2.5L6.5 2.5L6.5 1C6.5 0.723858 6.72386 0.5 7 0.5C7.27614 0.5 7.5 0.723858 7.5 1L7.5 2.5Z"
        stroke={props.color ?? "black"}
      />
    </svg>
  );
};
